import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LineChart } from 'lucide-react';

const DiscoverPriceTrendsUpsell: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      className="my-8 p-6 rounded-2xl bg-gradient-to-r from-emerald-50 to-cyan-50 dark:from-gray-800 dark:to-gray-900 border border-emerald-200 dark:border-emerald-700 shadow-lg flex flex-col sm:flex-row items-center justify-between gap-4 cursor-pointer hover:shadow-xl transition-all group"
      onClick={() => navigate('/prices/discover')}
      tabIndex={0}
      role="button"
      aria-label="Discover Price Trends in Ireland"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate('/prices/discover');
      }}
    >
      <div className="flex items-center gap-4">
        <div className="flex-shrink-0 bg-emerald-100 dark:bg-emerald-900 rounded-full p-3">
          <LineChart
            size={32}
            className="text-emerald-600 dark:text-emerald-300"
          />
        </div>
        <div>
          <h3 className="text-lg font-bold text-emerald-800 dark:text-emerald-200 mb-1">
            Explore Price Trends
          </h3>
          <p className="text-gray-700 dark:text-gray-300 text-sm max-w-xs">
            Discover historical and current rental price trends across Ireland.
            Compare areas, spot market shifts, and make informed decisions.
          </p>
        </div>
      </div>
      <button
        className="mt-4 sm:mt-0 px-6 py-2 rounded-full bg-emerald-600 text-white font-semibold shadow hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-400 transition-all"
        onClick={(e) => {
          e.stopPropagation();
          navigate('/prices/discover');
        }}
      >
        View Price Trends
      </button>
    </div>
  );
};

export default DiscoverPriceTrendsUpsell;
